import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { isNative } from '@/lib/platform';

export function useNativeUI() {
  useEffect(() => {
    // Add platform classes to body for CSS targeting
    const platform = Capacitor.getPlatform();
    const classList = typeof document !== 'undefined' ? document.body?.classList : undefined;
    if (platform === 'android') {
      classList?.add?.('capacitor-android');
    } else if (platform === 'ios') {
      classList?.add?.('capacitor-ios');
    }
    // Web gets neither class — web styles completely unchanged

    if (!isNative) return;

    if (!Capacitor.isPluginAvailable('StatusBar')) return;
    try {
      StatusBar.setStyle({ style: Style.Dark })?.catch?.(() => {});
      StatusBar.setBackgroundColor({ color: '#1A7A4A' }).catch(() => {
        // setBackgroundColor not available on iOS
      });
    } catch {
      // StatusBar plugin unavailable in this build — ignore
    }
  }, []);
}
